"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var gunEgg = {
    name: "gun",
    enabled: false,
    trigger: {
        type: "keys",
        keystrokes: ["g", "u", "n"],
        captureOnInputs: false
    },
    onStart: function () {
        var data = "https://i.imgur.com/jTSb37n.gif";
        var shock = document.createElement("div");
        var img = new Image();
        img.src = data;
        img.style.width = "600px";
        img.style.height = "500px";
        img.style.transition = "1s all";
        img.style.position = "fixed";
        img.style.left = "-374px";
        img.style.bottom = "calc(-50% + 400px)";
        img.style.zIndex = "999999";
        document.body.appendChild(img);
        window.setTimeout(function () {
            img.style.left = "calc(50% - 300px)";
            // $('body').css('background', 'salmon')
        }, 50);
        window.setTimeout(function () {
            img.style.left = "calc(120% + 300px)";
            // $('body').css('background', 'transparent')
        }, 4000);
        window.setTimeout(function () {
            img.parentNode.removeChild(img);
        }, 5000);
    },
};
exports.default = gunEgg;
